(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premier-pit-map"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var LEAFLET_CSS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
    var LEAFLET_JS  = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";

    /* ================================================================
       EDIT YOUR REPS HERE
       ----------------------------------------------------------------
       Each rep is defined once. Every pit points to a rep by the key on
       the left (danny, parker, devin, kyle). To update a phone or email,
       change it here one time and it updates on every pit that rep covers.
       Leave phone or email as "" if you do not have it yet; blank fields
       simply will not show in the popup.
       ================================================================ */
    var REPS = {
      danny:  { name:"Danny Jewell",  phone:"208-954-1119", email:"djewell@premierllc.net" },
      parker: { name:"Parker Price",  phone:"208-789-4086", email:"pprice@premierllc.net" },
      devin:  { name:"Devin Gudenau", phone:"208-921-0833", email:"dgudenau@premierllc.net" },
      kyle:   { name:"Kyle Hoch",     phone:"208-484-9811", email:"khoch@premierllc.net" }
    };

    /* ================================================================
       EDIT YOUR PITS HERE
       ----------------------------------------------------------------
       Addresses route the Get Directions buttons to the exact spot.
       To make any pin exact, right click the spot in Google Maps, click
       the coordinates to copy them, then paste into lat/lng below.

       The rep field is a key from the REPS list above. To reassign a
       pit to a different rep, change that key (for example rep:"danny"
       to rep:"parker"). Leave it as "" to show no rep for that pit.
       ================================================================ */
    var PITS = [
      { name:"Athol Pit",          lat:47.9200,   lng:-116.7800,   addr:"5023 Clagstone Rd, Spirit Lake, ID 83869",    dir:"5023 Clagstone Rd, Spirit Lake, ID 83869",     rep:"kyle" },
      { name:"Eaton Pit",          lat:46.4500,   lng:-116.9700,   addr:"26100 Central Grade Rd, Lewiston, ID 83501",  dir:"26100 Central Grade Rd, Lewiston, ID 83501",   rep:"kyle" },
      { name:"Armitage Pit",       lat:44.8390,   lng:-116.3780,   addr:"999 US-95, Indian Valley, ID 83632",          dir:"999 US-95, Indian Valley, ID 83632",           rep:"danny" },
      { name:"Sage Pit",           lat:43.787556, lng:-116.331806, addr:"Eagle, Idaho",                                dir:"43.787556,-116.331806",                        rep:"danny" },
      { name:"Badger Pit",         lat:43.8780,   lng:-116.5210,   addr:"2215 W Sales Yard Rd, Emmett, ID",            dir:"2215 W Sales Yard Rd, Emmett, ID",             rep:"danny" },
      { name:"Spring Creek Quarry",lat:43.9020,   lng:-116.4530,   addr:"5828 Spring Creek Road, Emmett, ID",          dir:"5828 Spring Creek Road, Emmett, ID",           rep:"parker" },
      { name:"Church Pit",         lat:43.9510,   lng:-116.3030,   addr:"9745 Liberty Rd, Sweet, ID 83670",            dir:"9745 Liberty Rd, Sweet, ID 83670",             rep:"parker" },
      { name:"Pintail Pit",        lat:43.8010,   lng:-116.9460,   addr:"26237 Deb Lane, Parma, ID",                   dir:"26237 Deb Lane, Parma, ID",                    rep:"danny" },
      { name:"Desert View Pit",    lat:43.4070,   lng:-116.3670,   addr:"9501 S Pleasant Valley Road, Boise, ID 83705",dir:"9501 S Pleasant Valley Road, Boise, ID 83705", rep:"danny" },
      { name:"Jack's Pit",         lat:43.4080,   lng:-116.3680,   addr:"9498 S Pleasant Valley Road, Boise, ID 83705",dir:"9498 S Pleasant Valley Road, Boise, ID 83705", rep:"danny" },
      { name:"Boise Pit",          lat:43.5100,   lng:-116.0450,   addr:"8770 E Blacks Creek Road, Boise, ID",         dir:"8770 E Blacks Creek Road, Boise, ID",          rep:"danny" },
      { name:"Big Wood Pit",       lat:43.4080,   lng:-114.2700,   addr:"10590 ID-75, Bellevue, ID",                   dir:"10590 ID-75, Bellevue, ID",                    rep:"devin" },
      { name:"Crystal Springs",    lat:42.5800,   lng:-114.6100,   addr:"2001 River Road, Filer, ID",                  dir:"2001 River Road, Filer, ID",                   rep:"devin" },
      { name:"McHenry Pit",        lat:42.593417, lng:-114.065972, addr:"McHenry, Idaho",                              dir:"42.593417,-114.065972",                        rep:"devin" },
      { name:"Declo Pit",          lat:42.513194, lng:-113.555528, addr:"Declo, Idaho",                                dir:"42.513194,-113.555528",                        rep:"devin" },
      { name:"Inkom Quarry",       lat:42.7900,   lng:-112.2680,   addr:"2199 W Portneuf Rd, Inkom, ID",               dir:"2199 W Portneuf Rd, Inkom, ID",                rep:"devin" }
    ];
    /* ---- Idaho border ----------------------------------------
       Coordinates from US Census Bureau cartographic boundary data,
       converted to Leaflet [lat,lng] format.
    ----------------------------------------------------------- */
    var IDAHO = [
      [49.00024,-116.04751],[47.97605,-116.04751],[47.69673,-115.72437],[47.42288,-115.71889],
      [47.30239,-115.5272],[47.25857,-115.32455],[47.18737,-115.30265],[46.919,-114.93021],
      [46.80946,-114.8864],[46.7054,-114.62351],[46.63968,-114.61255],[46.64516,-114.32227],
      [46.27272,-114.46467],[46.03721,-114.49206],[45.88386,-114.388],[45.77432,-114.56874],
      [45.67026,-114.49754],[45.56072,-114.54683],[45.45666,-114.33323],[45.59358,-114.08676],
      [45.70312,-113.98818],[45.60454,-113.80744],[45.52238,-113.83483],[45.33069,-113.73624],
      [45.12804,-113.57193],[45.05684,-113.45144],[44.86515,-113.45692],[44.78299,-113.3419],
      [44.77204,-113.13378],[44.4489,-113.00233],[44.39413,-112.88732],[44.48724,-112.78325],
      [44.48176,-112.47107],[44.56939,-112.24104],[44.5201,-112.10411],[44.56392,-111.86861],
      [44.50915,-111.81931],[44.54749,-111.61666],[44.75561,-111.38663],[44.58035,-111.2278],
      [44.47629,-111.04706],[42.00071,-111.04706],[41.99523,-112.16436],[41.99523,-114.04295],
      [42.00071,-117.02788],[43.83001,-117.02788],[44.15862,-116.89644],[44.24078,-116.97859],
      [44.25721,-117.17028],[44.39413,-117.24148],[44.75013,-117.03884],[44.78299,-116.93477],
      [44.93087,-116.83071],[45.02398,-116.84714],[45.14447,-116.73213],[45.31974,-116.67188],
      [45.61549,-116.46376],[45.75241,-116.54591],[45.82361,-116.78142],[45.9934,-116.91834],
      [46.16866,-116.92382],[46.34392,-117.05527],[46.42608,-117.03884],[47.76245,-117.04431],
      [49.00024,-117.03336],[49.00024,-116.04751]
    ];

    /* ---- nothing below needs editing for normal use ---- */

    function pinSVG(){
      return '<svg class="pm-pin" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">'
        + '<circle cx="11" cy="11" r="6.5" fill="#E08A2B" stroke="#ffffff" stroke-width="3"/></svg>';
    }

    // Load Leaflet once for the whole page, then run callback.
    function loadLeaflet(cb){
      if (window.L){ cb(); return; }

      if (!document.querySelector('link[data-pm-leaflet]')){
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = LEAFLET_CSS;
        link.setAttribute('data-pm-leaflet','');
        document.head.appendChild(link);
      }

      var existing = document.querySelector('script[data-pm-leaflet]');
      if (existing){
        existing.addEventListener('load', cb);
        return;
      }
      var s = document.createElement('script');
      s.src = LEAFLET_JS;
      s.setAttribute('data-pm-leaflet','');
      s.addEventListener('load', cb);
      document.head.appendChild(s);
    }

    // Build one map inside a given wrap element.
    function buildMap(wrap){
      var mapEl  = wrap.querySelector('[data-pm-map]');
      var listEl = wrap.querySelector('[data-pm-list]');
      if (!mapEl || !listEl) return;

      var map = L.map(mapEl, { scrollWheelZoom:false });
      wrap._pmMap = map; // stored so we can clean up on section unload
            var officePhone      = wrap.dataset.pmOfficePhone || "";
      var commercialLabel  = wrap.dataset.pmCommercialLabel || "Commercial and bulk orders";
      var residentialLabel = wrap.dataset.pmResidentialLabel || "Residential and small orders";
      var orderUrl         = wrap.dataset.pmOrderUrl || "";
      var orderLabel       = wrap.dataset.pmOrderLabel || "Order online";

           L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=cb1_3hla_1_585c26cbd53076055b2ef715',{
        attribution:'&copy; OpenStreetMap &copy; CARTO',
        maxZoom:19
      }).addTo(map);

      var icon = L.divIcon({
        className:'',
        html:pinSVG(),
        iconSize:[22,22],
        iconAnchor:[11,11],
        popupAnchor:[0,-10]
      });

      var WORLD = [[-85,-180],[-85,180],[85,180],[85,-180]];
      L.polygon([WORLD, IDAHO], {
        stroke:false, fillColor:"#ffffff", fillOpacity:0.40, interactive:false
      }).addTo(map);

      var idahoLayer = L.polygon(IDAHO, {
        color:"#323D3E", weight:2, opacity:0.85,
        fillColor:"#E08A2B", fillOpacity:0.07, interactive:false
      }).addTo(map);

      var markers = [];

      PITS.forEach(function(p, i){
        var gmaps = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(p.dir);

        var r = REPS[p.rep];
        var contact = "";

        if (r && (r.name || r.phone || r.email)){
          var repName  = r.name  ? '<div class="pm-pop-rep-name">' + r.name + '</div>' : "";
          var repPhone = r.phone ? '<a class="pm-pop-rep-line" href="tel:' + r.phone.replace(/[^0-9+]/g,'') + '">' + r.phone + '</a>' : "";
          var repEmail = r.email ? '<a class="pm-pop-rep-line" href="mailto:' + r.email + '">' + r.email + '</a>' : "";
          contact += '<div class="pm-pop-group"><div class="pm-pop-label">' + commercialLabel + '</div>' + repName + repPhone + repEmail + '</div>';
        }

        if (officePhone){
          var orderLink = orderUrl ? '<a class="pm-pop-rep-line pm-pop-order" href="' + orderUrl + '">' + orderLabel + '</a>' : "";
          contact += '<div class="pm-pop-group"><div class="pm-pop-label pm-pop-label--res">' + residentialLabel + '</div><a class="pm-pop-rep-line" href="tel:' + officePhone.replace(/[^0-9+]/g,'') + '">' + officePhone + '</a>' + orderLink + '</div>';
        }

        if (contact){ contact = '<div class="pm-pop-contact">' + contact + '</div>'; }

        var popup = '<div class="pm-pop-name">' + p.name + '</div>'
          + '<div class="pm-pop-addr">' + p.addr + '</div>'
          + contact
          + '<a class="pm-pop-link" href="' + gmaps + '" target="_blank" rel="noopener">Get Directions</a>';

        var m = L.marker([p.lat, p.lng], { icon: icon }).addTo(map).bindPopup(popup);
        markers.push(m);

        var row = document.createElement('div');
        row.className = 'pm-list-item';
        row.innerHTML = '<div class="name">' + p.name + '</div><div class="addr">' + p.addr + '</div>';
        row.addEventListener('click', function(){ focusPit(i); });
        listEl.appendChild(row);

        m.on('popupopen', function(){ setActive(i); });
      });

      function focusPit(i){
        var p = PITS[i];
        map.flyTo([p.lat, p.lng], 11, { duration:.8 });
        markers[i].openPopup();
        setActive(i);
      }
      function setActive(i){
        var rows = listEl.querySelectorAll('.pm-list-item');
        rows.forEach(function(el, idx){ el.classList.toggle('active', idx === i); });
        markers.forEach(function(m, idx){
          var el = m.getElement();
          if (el){
            var pin = el.querySelector('.pm-pin');
            if (pin) pin.classList.toggle('is-active', idx === i);
          }
        });
      }

      map.fitBounds(idahoLayer.getBounds().pad(0.04));

      // Map may be built while hidden (theme editor, tabs). Recalc on show.
      setTimeout(function(){ map.invalidateSize(); }, 200);
    }

    // Initialize every map instance on the page that is not yet ready.
    function initAll(scope){
      var root = scope || document;
      loadLeaflet(function(){
        var wraps = root.querySelectorAll('[data-pm-wrap]');
        wraps.forEach(function(wrap){
          if (wrap.dataset.pmReady) return;
          wrap.dataset.pmReady = '1';
          buildMap(wrap);
        });
      });
    }

    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', function(){ initAll(); });
    } else {
      initAll();
    }

    // Theme editor support: re-init when a section is added or reloaded,
    // and tear down cleanly when one is removed.
    document.addEventListener('shopify:section:load', function(e){
      initAll(e.target);
    });
    document.addEventListener('shopify:section:unload', function(e){
      var wrap = e.target.querySelector('[data-pm-wrap]');
      if (wrap && wrap._pmMap){
        wrap._pmMap.remove();
        wrap._pmMap = null;
        wrap.dataset.pmReady = '';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
